import { IRulerInfo, RulerModel } from '@/editor/entities/2d/rulerModel';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { LineSeg2d } from '@/editor/math/LineSeg2d';
import { Point2dUtils } from '@/editor/math/Point2dUtils';
import { globalStores } from '@/editor/stores';
import { calculateWindowDoorRulerInfos } from '@/editor/stores/utils/ruler/windowDoor';
import { EEntityType } from '@/editor/types';

interface IDWRulerInfo extends IRulerInfo {
  start: IPoint2d;
  end: IPoint2d;
  editable: boolean;
  // offset: number;
}

export class DWRulerController {
  private _dwId: string = '';
  private _rulerModel = new RulerModel<IDWRulerInfo>({
    onCommit: this.rulerOnChange.bind(this),
    onChange: this.rulerOnChange.bind(this)
  });

  private _disposeListener = () => {};

  constructor(dwId: string) {
    this._dwId = dwId;

    const disposeMovingObserve = globalStores.editorStateStore.onChange('moving', (isMoving) => {
      if (isMoving) {
        this._rulerModel.clear();
      } else {
        this.update();
      }
    });
    this._disposeListener = () => {
      disposeMovingObserve();
    };
  }

  // 标尺处理
  update() {
    if (!this._dwId) return;
    const dwData = globalStores.modelStore.getWindowData(this._dwId);
    if (!dwData) return;

    const rulerInfos = calculateWindowDoorRulerInfos(dwData);

    this._rulerModel.updateModel(
      rulerInfos.map((info) => ({ ...info, editable: true, focusTrap: true, blurOnCommit: true }))
    );
  }

  private rulerOnChange(id: string, value: number, rulerInfo: IDWRulerInfo) {
    const mainWDData = globalStores.modelStore.getWindowData(this._dwId);
    if (!mainWDData) return;

    let wallDirection: IPoint2d;

    if (mainWDData.relativeWallInfo.wallType === EEntityType.SeparateWall) {
      const relativeSepWallData = globalStores.separateWallStore.getSepData(
        mainWDData.relativeWallInfo.relativeWallId,
        false
      );
      if (!relativeSepWallData) return;
      wallDirection = new LineSeg2d(relativeSepWallData.start, relativeSepWallData.end).getDirectionVector();
    } else {
      const mainWallData = globalStores.wallStore.getWallData(mainWDData.relativeWallInfo.relativeWallId);
      if (!mainWallData) return;
      wallDirection = new LineSeg2d(mainWallData.baseData.start, mainWallData.baseData.end).getDirectionVector();
    }

    const oldDistance = Point2dUtils.distanceTo(rulerInfo.start, rulerInfo.end);
    const newDistance = value;
    const diffDistance = newDistance - oldDistance;
    const rulerCenter = Point2dUtils.getCenter(rulerInfo.start, rulerInfo.end);
    const projectDistance = Point2dUtils.projectScalar(
      wallDirection,
      Point2dUtils.subtracted(rulerCenter, mainWDData.center)
    );
    const isStartRuler = projectDistance < 0;

    const newCenter = Point2dUtils.addDistance(
      mainWDData.center,
      diffDistance * (isStartRuler ? 1 : -1),
      wallDirection
    );
    globalStores.windowDoorOperation.modifyWindowDoorCenter(mainWDData.id, newCenter);
    this.update();
  }

  dispose() {
    this._disposeListener();
    this._rulerModel.dispose();
  }
}
